import React, { useState, useEffect } from "react";
import {
  ChevronLeft,
  VideoCall,
  Videocam,
  VolumeUp,
} from "@mui/icons-material";
import "./MediaDevicesDropDown.css";

function MediaDevicesDropdown({
  selectedCameraDeviceId,
  selectedAudioDeviceId,
  onCameraChange,
  onAudioDeviceChange,
}) {
  const [devices, setDevices] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const getDevices = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
        const deviceList = await navigator.mediaDevices.enumerateDevices();

        const formattedDevices = deviceList.map((device) => ({
          deviceId: device.deviceId,
          kind: device.kind,
          label:
            device.label ||
            `${device.kind} (${device.deviceId.slice(0, 8)}...)`,
        }));

        setDevices(formattedDevices);
      } catch (error) {
        console.error("Error accessing media devices:", error);
      }
    };

    getDevices();

    navigator.mediaDevices.addEventListener("devicechange", getDevices);
    return () => {
      navigator.mediaDevices.removeEventListener("devicechange", getDevices);
    };
  }, []);

  const audioDevices = Array.from(
    new Map(
      devices
        .filter(
          (device) =>
            device.kind === "audioinput" || device.kind === "audiooutput"
        )
        .map((device) => [device.deviceId, device])
    ).values()
  );

  const videoDevices = Array.from(
    new Map(
      devices
        .filter((device) => device.kind === "videoinput")
        .map((device) => [device.deviceId, device])
    ).values()
  );

  const getSelectedStyle = (isSelected) => {
    return isSelected
      ? {
          backgroundColor: "#24B8E7",
          color: "white",
        }
      : {};
  };

  return (
    <div className={`mdd-dropdown ${isOpen ? "open" : ""}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="mdd-dropdown-button"
      >
        <span>Select Media Device</span>
        <ChevronLeft
          className={`mdd-icon-rotate ${isOpen ? "open" : ""}`}
          size={20}
        />
      </button>

      {isOpen && (
        <div className="mdd-dropdown-content">
          {videoDevices.length > 0 && (
            <div className="mdd-device-section">
              <div className="mdd-section-header">
                <Videocam size={16} />
                Video Devices
              </div>
              {videoDevices.map((device) => (
                <button
                  style={getSelectedStyle(
                    device.deviceId === selectedCameraDeviceId
                  )}
                  key={device.deviceId}
                  className="mdd-device-button"
                  onClick={() => {
                    console.log("Selected device:", device);
                    onCameraChange(device.deviceId);
                    setIsOpen(false);
                  }}
                >
                  {device.label}
                </button>
              ))}
            </div>
          )}
          {audioDevices.length > 0 && videoDevices.length > 0 && (
            <div className="mdd-divider" />
          )}

          {audioDevices.length > 0 && (
            <div className="mdd-device-section">
              <div className="mdd-section-header">
                <VolumeUp size={16} />
                Audio Devices
              </div>
              {audioDevices.map((device, index) => (
                <button
                  style={getSelectedStyle(
                    device.deviceId === selectedAudioDeviceId
                  )}
                  key={device.deviceId + index}
                  className="mdd-device-button"
                  onClick={() => {
                    console.log("Selected device:", device);
                    onAudioDeviceChange(device.deviceId);
                    setIsOpen(false);
                  }}
                >
                  {device.label}
                </button>
              ))}
            </div>
          )}

          {devices.length === 0 && (
            <div className="mdd-no-devices">No media devices found</div>
          )}
        </div>
      )}
    </div>
  );
}
export default MediaDevicesDropdown;
